import combineChildReducers from 'utils/combineChildReducers';
import {
  betaNodesReducer as betaNodes,
  fetchClonedFromJourneyReducer as clonedFromJourney,
  edgesReducer as edges,
  esFieldsReducer as esFields,
  fbCustomAudienceReducer as fbCustomAudience,
  fetchingReducer as fetching,
  flexMetricsReducer as flexMetrics,
  hasUnsavedChangesReducer as hasUnsavedChanges,
  isAsyncLoadingReducer as isAsyncLoading,
  isFetchingBetaNodesReducer as isFetchingBetaNodes,
  isFetchingEventFieldMappingsReducer as isFetchingEventFieldMappings,
  isFetchingFbCustomAudienceReducer as isFetchingFbCustomAudience,
  isMetricsSelectionEnabledReducer as isMetricsSelectionEnabled,
  isNodeEditorAsyncLoadingReducer as isNodeEditorAsyncLoading,
  isNodeOpeningReducer as isNodeOpening,
  isNotesVisibleReducer as isNotesVisible,
  isQuietHoursFeatureEnabledReducer as isQuietHoursFeatureEnabled,
  isYesNoSplitDataToggleEnabledReducer as isYesNoSplitDataToggleEnabled,
  isInProgressTotalPublishdViewEnabledReducer as isInProgressTotalPublishdViewEnabled,
  modalsReducer as modals,
  nextNodeIdReducer as nextNodeId,
  nodesReducer as nodes,
  openedNodeIdReducer as openedNodeId,
  originalNodesReducer as originalNodes,
  projectTimeZoneReducer as projectTimeZone,
  savingReducer as saving,
  takeoversReducer as takeovers,
  topLevelCustomEventsReducer as topLevelCustomEvents,
  updatingStatusReducer as updatingStatus,
  workflowReducer as workflow,
  workflowViewReducer as workflowView,
} from './reducers';

export * from './actions';
export * from './ducks.types';
export * from './sagas';
export * from './selectors';

export default combineChildReducers({
  edges,
  modals,
  takeovers,
  // betaNodes
  isFetchingBetaNodes,
  betaNodes,
  // esFields
  esFields,
  isFetchingEventFieldMappings,
  topLevelCustomEvents,
  fbCustomAudience,
  isFetchingFbCustomAudience,
  // nodes
  nextNodeId,
  isNodeOpening,
  nodes,
  openedNodeId,
  originalNodes,
  // workflow
  isAsyncLoading,
  isNodeEditorAsyncLoading,
  clonedFromJourney,
  workflow,
  fetching,
  flexMetrics,
  hasUnsavedChanges,
  saving,
  updatingStatus,
  workflowView,
  // notes
  isNotesVisible,
  // feature flags
  isMetricsSelectionEnabled,
  isQuietHoursFeatureEnabled,
  isYesNoSplitDataToggleEnabled,
  isInProgressTotalPublishdViewEnabled,
  // misc
  projectTimeZone,
});
